import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function ViewportTooSmall() {
  return (
    <MDBox
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        color: "text.secondary",
        textAlign: "center",
        p: 3,
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 48, color: "warning.main" }} />

      <MDTypography variant="h5" sx={{ fontWeight: 700 }}>
        Pantalla demasiado pequeña
      </MDTypography>

      <MDTypography sx={{ opacity: 0.8, maxWidth: "400px", fontSize: "0.9rem" }}>
        Amplía la ventana o utiliza un dispositivo con mayor resolución para poder usar el
        planificador cómodamente.
      </MDTypography>
    </MDBox>
  );
}
